import { QueryResults } from 'sql.js'

export type IStatus = 'IDLE' | 'EXTRACTING' | 'ANALYZING' | 'DOWNLOADING' | 'BROWSING'

export type HealthCheckKeyword =
  | 'HEALTH_CHECK_SELF_CONNECT_1'
  | 'HEALTH_CHECK_SELF_CONNECT_2'
  | 'HEALTH_CHECK_SELF_CONNECT_3'
  | 'HEALTH_CHECK_BLOCKED_THREAD'

export const HEALTH_CHECK_KEYWORDS: HealthCheckKeyword[] = [
  'HEALTH_CHECK_SELF_CONNECT_1',
  'HEALTH_CHECK_SELF_CONNECT_2',
  'HEALTH_CHECK_SELF_CONNECT_3',
  'HEALTH_CHECK_BLOCKED_THREAD',
]

export type AudioLatencyKeyword = 
  | 'AUDIO_NETWORK_LATENCY'

export const AUDIO_NETWORK_LATENCY_KEYWORDS: AudioLatencyKeyword[] = [
  'AUDIO_NETWORK_LATENCY'
]

export type NavigationalKeyword =
  | 'BEGINNING_OF_MAIN'
  | 'BEGINNING_OF_SYSTEM'
  | 'SOLSTICE_SERVER_CREATED'
  | 'LOGS_FETCHED'
  | 'GRACEFUL_SHUTDOWN'
  | 'PRE_INSTALL'
  | 'COPYING_APK'
  | 'INSTALLING_APK'
  | 'API_RESTART'
  | 'API_REBOOT'
  | 'SETTING_SYSTEM_TIME'
  | 'SETTING_TIME_DAY'

export const NAVIGATIONAL_KEYWORDS: NavigationalKeyword[] = [
  'BEGINNING_OF_MAIN',
  'BEGINNING_OF_SYSTEM',
  'SOLSTICE_SERVER_CREATED',
  'LOGS_FETCHED',
  'GRACEFUL_SHUTDOWN',
  'PRE_INSTALL',
  'COPYING_APK',
  'INSTALLING_APK',
  'API_RESTART',
  'API_REBOOT',
  'SETTING_SYSTEM_TIME',
  'SETTING_TIME_DAY',
]

export type CriticalKeyword =
  | 'TOO_MANY_OPEN_FILES'
  | 'COULD_NOT_CREATE_WAKE_PIPE'
  | 'OUT_OF_MEMORY'
  | 'DELAYED_DISK_WRITE'
  | 'STACK_CORRUPTION'
  | 'BAD_FIREWALL_RULE'
  | 'BEGINNING_OF_CRASH'
  | 'WIN_DEATH'
  | 'SKIPPED_FRAMES'
  | 'GL_OUT_OF_MEMORY'
  | 'CHROMIUM_OUT_OF_MEMORY'
  | 'GOOGLE_BREAKPAD'
  | 'POSSIBLE_DEADLOCK'
  | 'INSTALLING_RECOVERY_FAILED'
  | 'IOCTL'
  | 'SIGNAGE_CRASH'
  | 'SPLASH_SCREEN_DISCONNECTED'

export const CRITICAL_KEYWORDS: CriticalKeyword[] = [
  'TOO_MANY_OPEN_FILES',
  'COULD_NOT_CREATE_WAKE_PIPE',
  'OUT_OF_MEMORY',
  'DELAYED_DISK_WRITE',
  'STACK_CORRUPTION',
  'BAD_FIREWALL_RULE',
  'BEGINNING_OF_CRASH',
  'WIN_DEATH',
  'SKIPPED_FRAMES',
  'GL_OUT_OF_MEMORY',
  'CHROMIUM_OUT_OF_MEMORY',
  'GOOGLE_BREAKPAD',
  'POSSIBLE_DEADLOCK',
  'INSTALLING_RECOVERY_FAILED',
  'IOCTL',
  'SIGNAGE_CRASH',
  'SPLASH_SCREEN_DISCONNECTED',
]

export type MonitoringKeyword =
  | 'DUSTIN_SECOND_ETHERNET_FIX'
  | 'BAD_FILE_NUMBER'
  | 'DHCP_TIMED_OUT'
  | 'DHCP_BROADCASTING'
  | 'APPLY_PATCH_FAILED'

export const MONITORING_KEYWORDS: MonitoringKeyword[] = [
  'DUSTIN_SECOND_ETHERNET_FIX',
  'BAD_FILE_NUMBER',
  'DHCP_TIMED_OUT',
  'DHCP_BROADCASTING',
  'APPLY_PATCH_FAILED',
]

export type BlockedThreadKeyword = 'BLOCKED_THREAD_NOTIFICATIONTHREAD' | 'BLOCKED_THREAD_CONNECTIONMANAGER'

export const BLOCKED_THREAD_KEYWORDS: BlockedThreadKeyword[] = [
  'BLOCKED_THREAD_NOTIFICATIONTHREAD',
  'BLOCKED_THREAD_CONNECTIONMANAGER',
]

export type LogcatKeyword = 'LOGCAT_FILE'
export const LOGCAT_KEYWORDS = ['LOGCAT_FILE']

export type TombstoneKeyword = 'TOMBSTONE_FILE'
export const TOMBSTONE_KEYWORDS = ['TOMBSTONE_FILE']

export type BootLoopKeyword = 'FATAL_EXCEPTION_SYSTEM_PROCESS' | 'FAILED_BINDER_TRANSACTION'

export const BOOT_LOOP_KEYWORDS: BootLoopKeyword[] = ['FATAL_EXCEPTION_SYSTEM_PROCESS', 'FAILED_BINDER_TRANSACTION']

export type SuspiciousKeyword = 'WEBVIEW_HASNT_REQUESTED' | 'RETURN_RESULT_0x80000007'

export const SUSPICIOUS_KEYWORDS: SuspiciousKeyword[] = ['WEBVIEW_HASNT_REQUESTED', 'RETURN_RESULT_0x80000007']

export type KeywordType =
  | HealthCheckKeyword
  | NavigationalKeyword
  | CriticalKeyword
  | MonitoringKeyword
  | BlockedThreadKeyword
  | BootLoopKeyword
  | SuspiciousKeyword
  | LogcatKeyword
  | TombstoneKeyword
  | AudioLatencyKeyword

export interface IKeyword {
  alias: KeywordType // internal human readable name for filtering - e.g. 'BAD_FILE'
  info: string // description of why we care about this keyword
  name: string // to display in menu
  signature: string // unique string signature
}

export interface IIssue {
  fileId: number
  id: number
  info: string
  lineNumber: number
  name: string
  secondary?: string
  type: KeywordType
}

export interface IFile {
  content: string
  id: number
  name: string
  open: boolean
  path: string
}

export interface IStorage {
  available: number
  percent: string
  total: number
}

export interface ITemperature {
  fileId: number
  lineNumber: number
  max: number
}

export interface IMaxThreads {
  max: number
  lineNumber: number
  fileId: number
}

export type ChartType = 'TEMPERATURE' | 'THREADS' | 'CPU' | 'MEMORY'

export interface IChartPoint {
  chartType: ChartType
  fileId: number
  lineNumber: number
  timestamp: number
  [key: string]: string | number
}

export interface IState {
  buildNumber: string
  chartPoints: IChartPoint[]
  currentTab: number
  datastore: QueryResults
  files: IFile[]
  hardwareVariant: string
  issues: IIssue[]
  maxThreads: IMaxThreads
  solsticeVersion: string
  status: IStatus
  storage: IStorage
  temperature: ITemperature
  zipName: string
}



// WEBPACK FOOTER //
// ./src/types.ts